import { useGetListFromIds } from './useGetListFromIds'

export const subrequest = {
  getListFromIds: useGetListFromIds,
}
